import axios from 'axios';

const api_url = process.env.VUE_APP_API_VIDA_URL;

export default {
  async getProposalSensitiveData(proposalId) {
    try {
      const response = await axios.get(
        `${api_url}/inspection/${proposalId}/sensitive-data`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
